import React from 'react';
import Button from '../buttons/button';
import { useDispatch } from 'react-redux';
import Auth from '../../logic/redux/auth';
import { FormattedMessage } from 'react-intl';

const LogoutButton = (): JSX.Element => {
  const dispatch = useDispatch();
  const handleLogoutClick = (): void => {
    dispatch(Auth.actions.doLogout());
  };
  return (
    <Button secondary onClick={handleLogoutClick} style={{ width: '100%' }}>
      <FormattedMessage id={'common.logoutButton'} />
    </Button>
  );
};

export default LogoutButton;
